// extracted by mini-css-extract-plugin
export default {"main":"notFound_main__vXEnA","title":"notFound_title__Eivfd","home":"notFound_home__wvEmE"};